<template>
  <div>
    <a-menu
      :open-keys.sync="openKeys"
      :defaultSelectedKeys="['4-1']"
      :defaultOpenKeys="['4']"
      mode="inline"
      theme="dark"
      :inlineCollapsed="collapsed"
    >
      <a-menu-item key="1" @click="hrefSrc('1')">
        <a-icon type="home" />
        <span>返回主界面</span>
      </a-menu-item>
      <a-sub-menu key="2">
        <span slot="title">
          <a-icon type="audit" />
          <span>工单数据</span>
        </span>
        <a-menu-item key="2-1" @click="hrefSrc('2-1')">日工单</a-menu-item>
        <a-menu-item key="2-4" @click="hrefSrc('2-4')">月工单</a-menu-item>
        <!-- <a-menu-item key="2-2" @click="hrefSrc('2-2')">项目</a-menu-item> -->
        <!-- <a-menu-item key="2-3" @click="hrefSrc('2-3')">配置常用项</a-menu-item> -->
      </a-sub-menu>
      <a-sub-menu key="4">
        <span slot="title">
          <a-icon type="line-chart" />
          <span>运营数据</span>
        </span>
        <a-menu-item key="4-1" @click="hrefSrc('4-1')">员工战报</a-menu-item>
        <a-menu-item key="4-2" @click="hrefSrc('4-2')">项目战报</a-menu-item>
      </a-sub-menu>
      <a-sub-menu key="3">
        <span slot="title">
          <a-icon type="smile" />
          <span>用户权限</span>
        </span>
        <a-menu-item key="3-1" @click="hrefSrc('3-1')">门店</a-menu-item>
        <a-menu-item key="3-2" @click="hrefSrc('3-2')">员工</a-menu-item>
        <a-menu-item key="3-3" @click="hrefSrc('3-3')">管理员</a-menu-item>
      </a-sub-menu>
    </a-menu>
  </div>
</template>
<script>
export default {
  data() {
    return {
      collapsed: false,
      openKeys: ["1", "2", "3", "4"]
    };
  },
  methods: {
    hrefSrc(key) {
      switch (key) {
        case "1":
          this.$router.push({ name: "home" });
          break;
        case "2-1":
          this.$router.push({ name: "retailWorkOrder" });
          break;
        case "2-2":
          this.$router.push({ name: "retailProOrder" });
          break;
        case "2-3":
          this.$router.push({ name: "retailSetOrder" });
          break;
        case "2-4":
          this.$router.push({ name: "retailWorkOrderMonth" });
          break;
        case "3-1":
          this.$router.push({ name: "RetailShops" });
          break;
        case "3-2":
          this.$router.push({ name: "RetailWorker" });
          break;
        case "3-3":
          this.$router.push({ name: "RetailAdministrator" });
          break;
        case "4-1":
          this.$router.push({ name: "retailSettlement" });
          break;
        case "4-2":
          this.$router.push({ name: "retailProSettle" });
          break;
      }
    }
  }
};
</script>
